import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { analytics } from '@app/events/segment/analytics';

const JOB_LANDING_BANNER_DISMISSED_KEY = 'compass_job_landing_banner_dismissed';
const JOB_LANDING_LOCAL_KEY = 'compass_job_landing_data';

@Component({
  selector: 'app-job-landing-banner',
  imports: [],
  templateUrl: './job-landing-banner.component.html',
  styleUrl: './job-landing-banner.component.css',
})
export class JobLandingBannerComponent implements OnInit {
  @Input() entrypoint = '';
  @Input() section = '';
  @Output() shareCta = new EventEmitter<void>();

  protected visible = this.computeInitialVisibility();

  ngOnInit(): void {
    if (this.visible) {
      analytics.track('Job Landing Banner View', {
        entrypoint: this.entrypoint,
        section: this.section,
      });
    }
  }

  onShare(): void {
    this.shareCta.emit();
  }

  onDismiss(): void {
    localStorage.setItem(JOB_LANDING_BANNER_DISMISSED_KEY, 'true');
    this.visible = false;
    analytics.track('Job Landing Banner Dismiss', {
      entrypoint: this.entrypoint,
      section: this.section,
    });
  }

  hide(): void {
    this.visible = false;
  }

  private computeInitialVisibility(): boolean {
    const dismissed = localStorage.getItem(JOB_LANDING_BANNER_DISMISSED_KEY) === 'true';
    const alreadySubmitted = !!localStorage.getItem(JOB_LANDING_LOCAL_KEY);
    return !dismissed && !alreadySubmitted;
  }
}
